import AbstractWidget from "@/models/WebsiteWidget/AbstractWidget";
import WebsiteWidget from "@/models/WebsiteWidget/WebsiteWidget";

export default class CustomerReview extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/customer-review';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetCustomerReviews';

    static model_name = 'CustomerReview';

    static fields() {
		return {
			id: this.attr(null),
			country_id: this.attr(null),
			product_type_id: this.attr(null),
			package_type_id: this.attr(null),
			show_count: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			display_type: this.attr(null),
            widget: this.hasOne(WebsiteWidget, 'widgetable_id'),
		}
	}

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return WebsiteWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }

}
